import styled from 'styled-components';

export const PredefinedSelectContainer = styled.div`
  position: relative;
  height: 70px;
  select {
  position: absolute;
  top: 0;
  width: 300px;
  margin-bottom: 15px;
  }
  h3 {
    font-weight: 700;
  }
`;